import React, { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import { getCookie } from "../getcookie.js";

const apiUrl = process.env.REACT_APP_API_URL;
const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;

const apiUrl2 = process.env.REACT_APP_ADMIN_API_URL;
const header = {
  "Content-Type": "application/json; charset=UTF-8",
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*", // Required for CORS support to work
  Authorization: getCookie("mawalog"),
};

export const createVehicleApi = async (data) => {
  try {
    const response = await axios
      .post(apiUrl + `vehicle`, data, { headers: header })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log("error...", error.response);
        return error.response || { status: 500, data: { message: "Network Error" } };
      });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
    return { status: 500, data: { message: err.message } };
  } finally {
  }
};

export const getVehicleDetailsApi = async (vehicleId) => {
  try {
    const response = await axios.get(apiUrl + `vehicle/get/` + vehicleId, {
      headers: header,
    });
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getVehicleCustomer = async (vehicleNumber) => {
  try {
    const data = {
      vehicle_number: vehicleNumber,
    };
    const response = await axios.post(apiUrl + `get_vehicle_customers`, data, { headers: header });
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getTransporterListApi = async (term) => {
  try {
    const response = await axios.get(apiUrl + `get_transporters?term=${term}`, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching transporters:", err);
  }
};

export const getVendorListApi = async (term) => {
  try {
    const response = await axios.get(apiUrl + `get_vendors?term=${term}`, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching vendors:", err);
  }
};

export const getCustomerListApi = async (term) => {
  try {
    const response = await axios.get(apiUrl + `get_customers?term=${term}`, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching vendors:", err);
  }
};

export const getLocationFilterApi = async () => {
  try {
    const response = await axios.get(apiUrl2 + `get_location`, {
      headers: header,
    });
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getDepartmentFilterApi = async () => {
  try {
    const response = await axios.get(apiUrl2 + `get_department`, {
      headers: header,
    });
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const gateOutVehicleApi = async (data) => {
  try {
    const response = await axios
      .post(apiUrl + `vehicle_gate_out`, data, { headers: header })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log("error...", error.response);
        return error.response;
        /* if (error.response) {
          console.error("Error Status:", error.response.status);
          console.error("Error Data:", error.response.data);
       
        } else {
          console.error("Request failed:", error.message);
        } */
      });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
    return err.response;
  } finally {
  }
};
